export default [
  //Allgemeinmedizin",
  "Praktischer Arzt",
  "Hausarzt",
  "Allgemeiner Arzt",
  "Allgemeinmediziner",
  //Anästhesiologie",
  "Anästhesist",
  //Arbeitsmedizin",
  "Arbeitsmediziner",
  //Augenheilkunde",
  "Augenarzt",
  //Biochemie",
  //Chirurgie",
  "Chirurg",
  //Allgemeine Chirurgie",
  "Allgemeinchirurg",
  "Chirurg",
  //Gefäßchirurgie",
  "Gefäßchirurg",
  //Kinderchirurgie",
  "Kinderchirurg",
  //Orthopädie und Unfallchirurgie",
  "Orthopäde",
  "Unfallchirurg",
  //Plastische und Ästhetische Chirurgie",
  "Plastischer Chirurg",
  "Schönheitschirurg",
  //Thoraxchirurgie",
  "Toraxchirurg",
  //Viszeralchirurgie",
  "Viszeralchirurg",
  "Gefäßchirurg",
  //Frauenheilkunde und Geburtshilfe",
  "Gynäkologe",
  "Frauenarzt",
  //Hals-Nasen-Ohrenheilkunde",
  "Hals-Nasen-Ohrenarzt",
  "HNO Arzt",
  //Haut- und Geschlechtskrankheiten",
  "Hautarzt",
  "Dermathologe",
  //Humangenetik",
  "Humangenetiker",
  //Innere Medizin",
  "Internist",
  //Angiologie",
  "Angiologe",
  "Gefäßfacharzt",
  //Endokrinologie",
  "Endokrinologe",
  "Hormonarzt",
  //Gastroenterologie",
  "Gastroenterologe",
  "Magen-Darm Facharzt",
  //Hämatologie ",
  "Hämatologe",
  //Onkologie",
  "Onkologe",
  "Krebsfacharzt",
  //Nephrologie",
  "Nephrologe",
  "Nierenfacharzt",
  "Bluthochdruckfacharzt",
  //Pneumologie",
  "Pneumologe",
  "Lungenfacharzt",
  "Lungenarzt",
  "Pulmologe",
  //Rheumatologie",
  "Rheumatologe",
  //Kinder- und Jugendmedizin",
  "Kinderarzt",
  "Jungendarzt",
  //Neonatologie",
  //Pathologie",
  "Pathologe",
  //Neuropathologie",
  "Neuropathologe",
  //Pharmakologie",
  "Pharmakologe",
  //Toxikologie",
  "Toxikologe",
  //Physikalische und Rehabilitative Medizin",
  "Physikalischer Mediziner",
  "Rehabilitativer Mediziner",
  "Reha Arzt",
  //Radiologie",
  "Radiologe",
  //Kinderradiologie",
  "Kinderradiologe",
  //Neuroradiologie",
  "Neuroradiologe",
  //Rechtsmedizin",
  "Rechtsmediziener",
  //Strahlentherapie",
  "Strahlentherapeut",
  //Transfusionsmedizin",
  "Transfusionsmediziner",
  //Urologie",
  "Urologe",
  //Dermathologie",
  "Dermathologe",
  "Hautarzt",
  "Pulmologe",

  { value: "Kardiovaskularchirurgie", id: "herz" },
  { value: "Herzchirurg", id: "herz" },
  { value: "Kardiologie", id: "herz" },
  { value: "Kardiologe", id: "herz" },
  { value: "Herz-Kreislauf Facharzt", id: "herz" },
  { value: "Kinderkardiologie", id: "herz" },
  { value: "Kinderkardiologe", id: "herz" },

  { value: "Diabetologie", id: "diabetes" },
  { value: "Diabetologe", id: "diabetes" },

  { value: "Kinder- und Jugendpsychiatrie", id: "mental" },
  { value: "Kinderpsychiater", id: "mental" },
  { value: "Jugendpsychiater", id: "mental" },
  { value: "Kinder- und Jugendpsychotherapie", id: "mental" },
  { value: "Kinderpsychotherapeut", id: "mental" },
  { value: "Jugendpsychotherapeut", id: "mental" },
  { value: "Physiologie", id: "mental" },
  { value: "Physiologe", id: "mental" },
  { value: "Psychiatrie", id: "mental" },
  { value: "Psychiater", id: "mental" },
  { value: "Psychologe", id: "mental" },
  { value: "Psychotherapie", id: "mental" },
  { value: "Psychotherapeut", id: "mental" },
  { value: "Psychosomatische Medizin", id: "mental" },
  { value: "Psychosomatischer Mediziner", id: "mental" },
  { value: "Neurochirurgie", id: "mental" },
  { value: "Neurochirurg", id: "mental" },
  { value: "Neurologie", id: "mental" },
  { value: "Neurologe", id: "mental" },
  { value: "Nervenfacharzt", id: "mental" },
  { value: "Neuropädiatrie", id: "mental" },
  { value: "Neuropädiater", id: "mental" },

  { value: "Zahnarzt", id: "zahn" },
  { value: "Zahnmediziner", id: "zahn" },

  // { value: "Kieferorthopädie", id: "kiefer" },
  { value: "Kieferorthopäde", id: "kiefer" },
  { value: "Mund-Kiefer-Gesichtschirurgie", id: "kiefer" },
  { value: "Mundchirurg", id: "kiefer" },
  { value: "Kieferchirurg", id: "kiefer" },
  { value: "Gesichtschirurg", id: "kiefer" },
];
